'use client';
import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import { useCallback } from 'react';
// Single-file event: defined here at its only call site rather than in a shared package.
const keyboardShortcutTriggeredEvent = EVENT_PAYLOAD;
/**
 * Returns a stable `onShortcutFired` callback that fires a
 * `'keyboard shortcut triggered'` analytics event. Designed to be passed
 * as the `onShortcutFired` prop of `KeyboardShortcutsProvider`.
 */
export function useShortcutAnalytics() {
    const { track } = useInstrumentation();
    const pathname = usePathname();
    return useCallback((registration) => {
        const keybinding = Array.isArray(registration.keybinding)
            ? registration.keybinding.join(', ')
            : registration.keybinding;
        track(keyboardShortcutTriggeredEvent({
            name: 'keyboard shortcut triggered',
            data: {
                shortcut_id: registration.id,
                keybinding,
                label_id: String(registration.label.id),
                source_page: pathname ?? '/',
            },
        }));
    }, [track, pathname]);
}
//# sourceMappingURL=useShortcutAnalytics.js.map